import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { CollectionSummary } from "./components/CollectionSummary";
import { BeforeAfter } from "./components/BeforeAfter";
import { PainPoints } from "./components/PainPoints";
import { Volumes } from "./components/Volumes";
import { Resources } from "./components/Resources";
import { Bonuses } from "./components/Bonuses";
import { Testimonials } from "./components/Testimonials";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { AuthorMessage } from "./components/AuthorMessage";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="relative min-h-screen w-full overflow-x-hidden bg-ink font-sans text-cream" data-id="element-0" data-mp="23ujjma5idj2g">
      <MetaPixel data-id="element-1" data-mp="3ij64a9st9l7v" />
      <Hero data-id="element-2" data-mp="3ijpcgysnsv8p" />
      <main data-id="element-3" data-mp="3ihv1ac76whht">
        <CollectionSummary data-id="element-4" data-mp="3mljat0fdtn5p" />
        <BeforeAfter data-id="element-5" data-mp="3mkre1ma1tjdu" />
        <PainPoints data-id="element-6" data-mp="3mk84asujy1aw" />
        <Volumes data-id="element-7" data-mp="3mjpyp5m02aqb" />
        <Resources data-id="element-8" data-mp="3mj6lu3b7icj5" />
        <Bonuses data-id="element-9" data-mp="3rbr9so7flver" />
        <Testimonials data-id="element-10" data-mp="3rdaquh0wwahl" />
        <Offer data-id="element-11" data-mp="3rcswxr1q28cu" />
        <Guarantee data-id="element-12" data-mp="3recd7hndojem" />
        <AuthorMessage data-id="element-13" data-mp="5yhupa6n3cr" />
        <FAQ data-id="element-14" data-mp="67yhm9c7y5s" />
        <FinalCTA data-id="element-15" data-mp="4wyzymxdckh" />
      </main>
      <Footer data-id="element-16" data-mp="82ld64660ci" />
      <FloatingCTA data-id="element-17" data-mp="7sxbo2oq39g" />
      <PurchasePopup data-id="element-18" data-mp="2zllf11m4wkmq" />
    </div>;
}